// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 640px) {\n.loader-desktop[data-v-eed1de30] {\n    display: none;\n}\n}", ""]);
// Exports
module.exports = exports;
